// =============================================================================
// Super Admin — Routes
// =============================================================================

export const ROUTES = {
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  DASHBOARD: "/app",
  OVERVIEW: "/app",
  CLIENTS: "/app/clients",
  CLIENT_DETAIL: "/app/clients/:id",
  CUSTOMERS_GLOBAL: "/app/customers/global",
  CUSTOMERS_RESTAURANT: "/app/customers/restaurant",
  ORDERS: "/app/orders",
  ORDER_DETAIL: "/app/orders/:id",
  PAYMENTS: "/app/payments",
  REPORTS: "/app/reports",
  DRIVERS: "/app/drivers",
  PARTNERS: "/app/partners",
  PARTNER_DETAIL: "/app/partners/:id",
  SETTINGS: "/app/settings",
  APP_SETTINGS: "/app/app-settings",
} as const;

export const APP_ROUTE_PATHS = new Set<string>([
  ROUTES.OVERVIEW,
  ROUTES.CLIENTS,
  ROUTES.CUSTOMERS_GLOBAL,
  ROUTES.CUSTOMERS_RESTAURANT,
  ROUTES.ORDERS,
  ROUTES.PAYMENTS,
  ROUTES.REPORTS,
  ROUTES.DRIVERS,
  ROUTES.PARTNERS,
  ROUTES.SETTINGS,
  ROUTES.APP_SETTINGS,
]);

export function clientDetailPath(id: string) {
  return `/app/clients/${id}`;
}

export function partnerDetailPath(id: string) {
  return `/app/partners/${id}`;
}

export function orderDetailPath(id: string) {
  return `/app/orders/${id}`;
}
